import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography,
  Grid,
  Button,
  TextField,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip
} from '@mui/material';
import { Watchlist } from '../../types/investment';
import { WatchlistManager } from './WatchlistManager';

interface WatchlistsProps {
  profileId: string;
  profile: {
    id: string;
    name: string;
    investment_profile_template: string;
    created_at: string;
    updated_at: string;
    watchlists: Watchlist[];
    screeners: any[];
  };
  urlBase: string;
}

const Watchlists: React.FC<WatchlistsProps> = ({ profileId, profile, urlBase }) => {
  return (
    <Box p={3}>
      <WatchlistManager
        profileId={profileId}
        profile={profile}
        />
    </Box>
  );
};

// interface FavoritesState {
//   [key: string]: boolean;
// }

// const Watchlists: React.FC<WatchlistsProps> = ({ profileId, profile, urlBase }) => {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);
//   const [watchlists, setWatchlists] = useState<Watchlist[]>([]);
//   const [tickerData, setTickerData] = useState<Record<string, any>>({});
//   const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
//   const [newWatchlistName, setNewWatchlistName] = useState('');
//   const [newWatchlistTickers, setNewWatchlistTickers] = useState('');
//   const [watchlistToDelete, setWatchlistToDelete] = useState<string | null>(null);
//   const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
//   const [editWatchlist, setEditWatchlist] = useState<Watchlist | null>(null);
//   const [editWatchlistName, setEditWatchlistName] = useState('');
//   const [editWatchlistTickers, setEditWatchlistTickers] = useState('');
//   const [selectedTicker, setSelectedTicker] = useState<string | null>(null);
//   const [tickerDetailData, setTickerDetailData] = useState<any>(null);
//   const [favorites, setFavorites] = useState<FavoritesState>({});
  
//   // Use auth context
//   const { getAuthHeaders } = useAuth();
//   const api = investmentAPI();

//   useEffect(() => {
//     const fetchWatchlists = async () => {
//       try {
//         setLoading(true);
//         // Initialize with profile watchlists if available
//         if (profile?.watchlists) {
//           setWatchlists(profile.watchlists);
//         }
        
//         // Fetch latest watchlists
//         const data = await api.getWatchlists(profileId);
//         setWatchlists(data);
        
//         // Fetch ticker data for all watchlist tickers
//         if (data && data.length > 0) {
//           const allTickers = [...new Set(data.flatMap((w: Watchlist) => w.tickers))];
//           const tickerPromises = allTickers.map((ticker: string) => api.getTickerData(ticker));
//           const tickerResults = await Promise.all(tickerPromises);
//           const newTickerData = tickerResults.reduce<Record<string, any>>((acc, data, index) => {
//             acc[allTickers[index]] = data[0];
//             return acc;
//           }, {});
//           setTickerData(newTickerData);
//         }

//         // Initialize favorites state
//         const initialFavorites: FavoritesState = data.reduce((acc, watchlist) => ({
//           ...acc,
//           [watchlist.id]: watchlist.favorite || false
//         }), {} as FavoritesState);
        
//         setFavorites(initialFavorites);
//       } catch (err) {
//         setError(err instanceof Error ? err.message : 'Failed to fetch watchlists');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchWatchlists();
//   }, [profileId, profile?.investment_profile_template]);

//   const handleCreateWatchlist = async () => {
//     try {
//       const tickers = newWatchlistTickers.toUpperCase().split(',').map(t => t.trim()).filter(Boolean);
      
//       if (tickers.length === 0) {
//         setError('Please enter at least one ticker');
//         return;
//       }

//       setLoading(true);
//       const newWatchlist = await api.createWatchlist({
//         profile_id: profileId,
//         name: newWatchlistName,
//         tickers: tickers
//       });
      
//       // Ensure newWatchlist has the expected structure
//       const watchlistWithTickers = {
//         ...newWatchlist,
//         tickers: tickers,
//         id: newWatchlist.id || Date.now().toString() // Fallback ID if none provided
//       };
      
//       // Fetch data for new tickers
//       // const tickerPromises = tickers.map(ticker => api.getTickerData(ticker));
//       // const tickerResults = await Promise.all(tickerPromises);
//       const newTickerData = await api.getMultiTickerData(tickers);
//       // const newTickerData = tickerResults.reduce<Record<string, any>>((acc, data, index) => {
//       //   if (data && data[0]) {
//       //     acc[tickers[index]] = data[0];
//       //   }
//       //   return acc;
//       // }, {});
      
//       setTickerData(prev => ({ ...prev, ...newTickerData }));
//       setWatchlists([...watchlists, watchlistWithTickers]);
//       setIsCreateDialogOpen(false);
//       setNewWatchlistName('');
//       setNewWatchlistTickers('');
//       setError(null);
//     } catch (err) {
//       setError(err instanceof Error ? err.message : 'Failed to create watchlist');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDeleteWatchlist = async () => {
//     if (!watchlistToDelete) return;
    
//     try {
//       setLoading(true);
//       await api.deleteWatchlist(profileId, watchlistToDelete);
      
//       // Update local state
//       setWatchlists(prevWatchlists => 
//         prevWatchlists.filter(w => w.id !== watchlistToDelete)
//       );
      
//       setWatchlistToDelete(null);
//       setConfirmDeleteOpen(false);
//     } catch (err) {
//       console.error('Delete error:', err);
//       setError(err instanceof Error ? err.message : 'Failed to delete watchlist');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditOpen = (watchlist: Watchlist) => {
//     setEditWatchlist(watchlist);
//     setEditWatchlistName(watchlist.name);
//     setEditWatchlistTickers(watchlist.tickers.join(', '));
//   };

//   const handleUpdateWatchlist = async () => {
//     if (!editWatchlist) return;
    
//     try {
//       setLoading(true);
//       const tickers = editWatchlistTickers.toUpperCase().split(',').map(t => t.trim()).filter(Boolean);
      
//       const updatedWatchlist = await api.updateWatchlist({
//         id: editWatchlist.id,
//         profile_id: profileId,
//         name: editWatchlistName || editWatchlist.name,
//         tickers: tickers
//       });
      
//       // Fetch data for any new tickers
//       // const tickerPromises = tickers.map(ticker => api.getTickerData(ticker));
//       // const tickerResults = await Promise.all(tickerPromises);
//       const newTickerData = await api.getMultiTickerData(tickers);
//       // const newTickerData = tickerResults.reduce<Record<string, any>>((acc, data, index) => {
//       //   if (data && data[0]) {
//       //     acc[tickers[index]] = data[0];
//       //   }
//       //   return acc;
//       // }, {});
      
//       // Update both ticker data and watchlists state
//       setTickerData(prev => ({ ...prev, ...newTickerData }));
//       setWatchlists(prevWatchlists => 
//         prevWatchlists.map(w => w.id === editWatchlist.id ? {
//           ...updatedWatchlist,
//           name: editWatchlistName || editWatchlist.name,
//           tickers: tickers // Ensure we have the latest tickers array
//         } : w)
//       );
      
//       setEditWatchlist(null);
//     } catch (err) {
//       setError(err instanceof Error ? err.message : 'Failed to update watchlist');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleTickerSelect = async (ticker: string) => {
//     try {
//       const data = await api.getTickerData(ticker);
//       setTickerDetailData(data[0]);
//       setSelectedTicker(ticker);
//     } catch (err) {
//       setError(err instanceof Error ? err.message : 'Failed to fetch ticker data');
//     }
//   };

//   const handleToggleFavorite = async (watchlist: Watchlist) => {
//     try {
//       const newFavoriteState = !favorites[watchlist.id];
//       console.log('Toggling favorite for watchlist:', {
//         watchlistId: watchlist.id,
//         currentState: favorites[watchlist.id],
//         newState: newFavoriteState
//       });
      
//       // Optimistic update
//       setFavorites(prev => ({
//         ...prev,
//         [watchlist.id]: newFavoriteState
//       }));

//       // Create update payload
//       const updatePayload = {
//         id: watchlist.id,
//         profile_id: profileId,
//         name: watchlist.name,
//         tickers: watchlist.tickers,
//         favorite: newFavoriteState
//       };

//       console.log('Sending update payload:', updatePayload);

//       // Update on backend
//       const updatedWatchlist = await api.updateWatchlist(updatePayload);
//       console.log('Received updated watchlist:', updatedWatchlist);

//       // Update watchlists state while preserving ticker data
//       setWatchlists(prev => prev.map(w => 
//         w.id === watchlist.id ? {
//           ...updatedWatchlist,
//           tickers: watchlist.tickers // Keep existing tickers
//         } : w
//       ));

//     } catch (err) {
//       console.error('Error updating favorite status:', err);
//       // Revert on error
//       setFavorites(prev => ({
//         ...prev,
//         [watchlist.id]: !prev[watchlist.id]
//       }));
//       setError(err instanceof Error ? err.message : 'Failed to update favorite status');
//     }
//   };

//   const getActions = (watchlist: Watchlist) => [
//     { 
//       icon: favorites[watchlist.id] ? <StarIcon color="primary" /> : <StarBorderIcon />,
//       label: favorites[watchlist.id] ? 'Remove from Favorites' : 'Add to Favorites',
//       onClick: () => handleToggleFavorite(watchlist)
//     },
//     { icon: <EditIcon />, label: 'Edit', onClick: () => handleEditOpen(watchlist) },
//     { icon: <DeleteIcon />, label: 'Delete', onClick: () => {
//       setWatchlistToDelete(watchlist.id);
//       setConfirmDeleteOpen(true);
//     }}
//   ];

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" p={3}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Box p={3}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
//         <Typography variant="h5">Watchlists</Typography>
//         <Button
//           variant="contained"
//           startIcon={<AddIcon />}
//           onClick={() => setIsCreateDialogOpen(true)}
//           disabled={watchlists.length >= 10}
//         >
//           Create Watchlist
//         </Button>
//       </Box>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

//       <Grid container spacing={2}>
//         {watchlists.map((watchlist) => (
//           <Grid item xs={12} md={6} lg={4} key={watchlist.id}>
//             <TableCard
//               title={watchlist.name}
//               data={watchlist.tickers?.map((ticker: string) => tickerData[ticker]).filter(Boolean) || []}
//               onTickerSelect={handleTickerSelect}
//               actions={getActions(watchlist)}
//             />
//           </Grid>
//         ))}
//       </Grid>

//       <Dialog 
//         open={isCreateDialogOpen} 
//         onClose={() => setIsCreateDialogOpen(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>Create New Watchlist</DialogTitle>
//         <DialogContent>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Watchlist Name"
//             fullWidth
//             value={newWatchlistName}
//             onChange={(e) => setNewWatchlistName(e.target.value)}
//             sx={{ mb: 2 }}
//           />
//           <TextField
//             margin="dense"
//             label="Tickers (comma-separated)"
//             fullWidth
//             value={newWatchlistTickers}
//             onChange={(e) => setNewWatchlistTickers(e.target.value.toUpperCase())}
//             helperText="Example: AAPL, MSFT, GOOGL"
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setIsCreateDialogOpen(false)}>Cancel</Button>
//           <Button 
//             onClick={handleCreateWatchlist}
//             variant="contained"
//             disabled={!newWatchlistName || !newWatchlistTickers}
//           >
//             Create
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog
//         open={confirmDeleteOpen}
//         onClose={() => {
//           setConfirmDeleteOpen(false);
//           setWatchlistToDelete(null);
//         }}
//       >
//         <DialogTitle>Delete Watchlist</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to delete this watchlist? This action cannot be undone.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button 
//             onClick={() => {
//               setConfirmDeleteOpen(false);
//               setWatchlistToDelete(null);
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleDeleteWatchlist}
//             color="error"
//             variant="contained"
//           >
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog
//         open={!!editWatchlist}
//         onClose={() => setEditWatchlist(null)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>Edit Watchlist</DialogTitle>
//         <DialogContent>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Watchlist Name"
//             fullWidth
//             value={editWatchlistName}
//             onChange={(e) => setEditWatchlistName(e.target.value)}
//             sx={{ mb: 2 }}
//           />
//           <TextField
//             margin="dense"
//             label="Tickers (comma-separated)"
//             fullWidth
//             value={editWatchlistTickers}
//             onChange={(e) => setEditWatchlistTickers(e.target.value.toUpperCase())}
//             helperText="Example: AAPL, MSFT, GOOGL"
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setEditWatchlist(null)}>Cancel</Button>
//           <Button 
//             onClick={handleUpdateWatchlist}
//             variant="contained"
//             disabled={!editWatchlistName || !editWatchlistTickers}
//           >
//             Update
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog
//         open={!!selectedTicker}
//         maxWidth="md"
//         fullWidth
//         onClose={() => setSelectedTicker(null)}
//       >
//         <DialogTitle sx={{ m: 0, p: 2 }}>
//           <IconButton
//             aria-label="close"
//             onClick={() => setSelectedTicker(null)}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           {tickerDetailData && (
//             <TickerDetailView 
//               tickerInfo={tickerDetailData}
//               ticker={selectedTicker!}
//               onBack={() => setSelectedTicker(null)}
//             />
//           )}
//         </DialogContent>
//       </Dialog>
//     </Box>
//   );
// };

export default Watchlists;